module.exports = __webpack_public_path__ + "static/media/lagesa_logo.ba4ac5e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/templates/AboutUs/images/lagesa_logo.png
// module id = 1602
// module chunks = 0